module.exports = __webpack_public_path__ + "./img/f29be98b626026995753e1ff013ba4ba.png";